<script>
export default {
  name: 'XDivider',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div class="x-divider">
    <div class="x-divider__line"></div>
    <div v-if="label" class="x-divider__label t3 -t_regular" v-text="label"></div>
    <div class="x-divider__line"></div>
  </div>
</template>

<style lang="scss" scoped>
.x-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  width: 100%;

  &__label {
    color: $context-color-3;
    margin-left: 1rem;
    margin-right: 1rem;
  }

  &__line {
    background-color: $context-color-6;
    flex-grow: 1;
    height: 1px;
  }
}
</style>
